import { createContext } from "react";

export interface FeatureFlagsContextValue {
  /**
   * Slice 11 live credential flow (`api-portal-live-credentials`, AES-387).
   * AES-388 uses it for the live approve confirmation.
   * Fail-closed when LaunchDarkly is on.
   */
  liveCredentialsEnabled: boolean;
  /**
   * Imported sandbox credentials without a test location
   * (`api-portal-imported-sandbox-credentials`, AES-406).
   * Fail-closed when LaunchDarkly is on.
   */
  importedSandboxCredentialsEnabled: boolean;
  /**
   * Imported live credentials support notice
   * (`api-portal-imported-credentials-support`, AES-405).
   * Fail-closed when LaunchDarkly is on.
   */
  importedCredentialsSupportEnabled: boolean;
  /**
   * False while LaunchDarkly is still evaluating for the current identity.
   * The fail-closed values are indistinguishable from a real "off", so acting
   * on them early would send a remembered session to the legacy experience.
   */
  flagsResolved: boolean;
}

/**
 * Defaults when LaunchDarkly is not configured (local).
 * Sandbox credentials, contestation, imported integrators, and the docs
 * landing are always on. With LD enabled, live credentials, imported sandbox
 * credentials without a location, and the imported credentials support notice
 * fail closed.
 */
export const defaultFeatureFlags: FeatureFlagsContextValue = {
  liveCredentialsEnabled: true,
  importedSandboxCredentialsEnabled: true,
  importedCredentialsSupportEnabled: true,
  flagsResolved: true,
};

export const FeatureFlagsContext =
  createContext<FeatureFlagsContextValue>(defaultFeatureFlags);
